<div class="paginator-container">
  <div class="paginator">
    <div class="col-md-2">
      <div class="paginator-label">
        {{ paginatorLabel }}
        @if (tooltipLabel) {
          <span class="tooltiptext">{{ tooltipLabel }}</span>
        }
      </div>
    </div>
    <div class="col-md-7 text-center">
      @if (maxItemCount && getNumberOfPages() > 1) {
        <div class="page-counter">
          <button
            type="button"
            class="button button-small navigation-button"
            [disabled]="getCurrentPageNumber() === 1"
            (click)="previousPage()"
          >
            <i [ngClass]="Icons.ANGLE_LEFT"></i>
          </button>
          <div class="page-numbers">
            <div class="page-number" [class.active]="1 === getCurrentPageNumber()" (click)="setCurrentPage(1)">1</div>
            <!-- Only display left side placeholder if there are more than 6 pages and we are beyond the 5th page. -->
            @if (displayLowerPlaceholder()) {
              <div class="page-placeholder">...</div>
            }
            @for (n of getNumberOfPages() - 2 | repeat; track n) {
              <!-- We display the first and last elements separately, so we need to add 2 to the counter -->
              @if (shouldDisplayPageNumber(n + 2)) {
                <div class="page-number" [class.active]="n + 2 === getCurrentPageNumber()" (click)="setCurrentPage(n + 2)">
                  {{ n + 2 }}
                </div>
              }
            }
            <!-- Only display right side placeholder if there are more than 9 pages and we are further than 4 pages away from the last page. -->
            @if (displayUpperPlaceholder()) {
              <div class="page-placeholder">...</div>
            }
            <div
              class="page-number"
              [class.active]="getNumberOfPages() === getCurrentPageNumber()"
              (click)="setCurrentPage(getNumberOfPages())"
            >
              {{ getNumberOfPages() }}
            </div>
          </div>
          <button
            type="button"
            class="button button-small navigation-button"
            (click)="nextPage()"
            [disabled]="filter.offset + filter.pageSize >= maxItemCount"
          >
            <i [ngClass]="Icons.ANGLE_RIGHT"></i>
          </button>
        </div>
      }
    </div>
    <div class="col-md-3">
      @if (maxItemCount) {
        <div class="result-box pull-right">
          <div class="result-per-page-label">Results per page:</div>
          <app-dropdown-select (onValueSelect)="changePageSize($any($event))" type="narrow" [values]="pageSizes" direction="up right">
            <button type="button" class="button button-small dropdown-button">
              {{ filter.pageSize }}
              <i [ngClass]="Icons.ANGLE_DOWN"></i>
            </button>
          </app-dropdown-select>
        </div>
      }
    </div>
  </div>
</div>
